<div class="d-flex flex-column align-items-start gap-1">
  <span>{{ 'inquiry.directlyInquired' | translate }}:</span>
  <span>{{ profileName }}</span>
  <span>{{ branchName }}</span>
</div>
